import { getToken } from '@/libs/util.token'
export default ({ request }) => ({
  SYS_UPLOAD(file, timeout = 0) {
    let formData = new FormData()
    formData.append('file', file)
    formData.append('expirationsec', 0)
    formData.append('fileproperty', 'publicfiles')
    const data = {
      url: '/oss/ossUploadReturnUrlAndFileId',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getToken() || ''
      },
      data: formData,
      sign: false,
    }
    if (timeout) data.timeout = timeout
    return request(data)
  },
})
